import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 640;

const getIsMobile = () =>
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT;

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean>(getIsMobile);

    useEffect(() => {
        let rafId: number;

        const check = () => {
            // rAF으로 브라우저가 레이아웃을 완전히 계산한 뒤 읽음
            rafId = requestAnimationFrame(() => {
                setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
            });
        };

        // 마운트 시점 동기화 (초기값이 틀릴 경우 보정)
        check();

        window.addEventListener('resize', check);
        window.addEventListener('orientationchange', check);

        return () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener('resize', check);
            window.removeEventListener('orientationchange', check);
        };
    }, []);

    return isMobile;
};
